// extracted by mini-css-extract-plugin
export default {"input":"ForgotPasswordForm_input__N3F2-","errored":"ForgotPasswordForm_errored__oH8xJ","error":"ForgotPasswordForm_error__+HStz","grid":"ForgotPasswordForm_grid__iJUw-"};